/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import ReactGA from "react-ga4";
import { hasConsent } from "./cookieConsentService";
import { googleAnalyticsConfig } from "./universalAnalytics";

export function gaTerminate() {
  const { trackingId } = googleAnalyticsConfig();
  // @ts-ignore
  window[`ga-disable-${trackingId}`] = true;
}

export function gaInitialize() {
  const { trackingId } = googleAnalyticsConfig();
  // @ts-ignore
  window[`ga-disable-${trackingId}`] = false;

  ReactGA.initialize(trackingId);
}

export function gaSet(data: Parameters<typeof ReactGA["set"]>[0]) {
  if (!hasConsent("analytics")) {
    return;
  }
  ReactGA.set(data);
}

export function gaEvent(data: Parameters<typeof ReactGA["event"]>[0]) {
  if (!hasConsent("analytics")) {
    return;
  }
  ReactGA.event(data);
}
